const isDev = process.env.NODE_ENV === 'development';

const PROD_API_ORIGIN = 'https://japancupid.cyou';
const PROD_WS_ORIGIN = 'wss://japancupid.cyou';

// 开发环境走本地代理，生产环境直连后端域名，避免依赖前端站点反代。
const VUE_APP_BASEURL = isDev ? '/dev-api' : PROD_API_ORIGIN;

const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
const WS_DOMAIN = `${wsProtocol}://${window.location.host}`;
const wsBasePath = '/websocket/message';
const VUE_APP_WS_URL = isDev
	? `${WS_DOMAIN}${wsBasePath}`
	: `${PROD_WS_ORIGIN}/api/websocket/message`;

export { VUE_APP_WS_URL, VUE_APP_BASEURL };